<template>
  <div>

    <div v-if="isMobile" class="d-flex align-items-center p-2 bg-light shadow-sm sticky-top">
      <b-button variant="link" class="p-0 mr-2" @click="drawerOpen = true">
        <b-icon-list></b-icon-list>
      </b-button>
      <span class="font-weight-bold">{{ activeTabTitle }}</span>
    </div>

    <b-sidebar
      id="admintools-drawer"
      title="Process Sales Menu"
      bg-variant="light"
      text-variant="dark"
      shadow
      backdrop
      placement="left"
      :visible="drawerOpen"
      @hidden="drawerOpen = false"
    >
      <hr/>
      <ul class="list-unstyled m-0">
        <li v-for="(tab, index) in filteredTabs" :key="index" class="mb-2">
          <b-button
            block
            squared
            :variant="activeTabIndex === index ? null : 'link'"
            class="text-left"
            @click="selectTab(index)"
          >
            <b-icon :icon="tab.icon" class="mr-2"></b-icon>
            {{ tab.title }}
          </b-button>
        </li>
      </ul>
    </b-sidebar>

    <div v-if="!isMobile">
      <b-tabs card lazy v-model="activeTabIndex">
        <b-tab
          v-for="(tab, index) in filteredTabs"
          :key="index"
          :title="tab.title"
        >
          <keep-alive>
            <component :is="tab.component"></component>
          </keep-alive>
        </b-tab>
      </b-tabs>
    </div>

    <div v-if="isMobile" class="mt-2">
      <keep-alive>
        <component v-if="activeTabComponent" :is="activeTabComponent"></component>
      </keep-alive>
    </div>

  </div>
</template>

<script>
import {
  BIconList, BIconClipboard, BIconArchive, BIconBox, BIconTruck, BIconFileText, BIconExclamationTriangle, BIconCalendar 
} from "bootstrap-vue";


import AdminToolsDeliveryCalendar from "@/components/AdminTools/AdminToolsDeliveryCalendar";
import AdminToolsDeliveryOperations from "@/components/AdminTools/AdminToolsDeliveryOperations";

export default {
  name: "DeliveryCalendarMain",

  components: {
 
    AdminToolsDeliveryCalendar,
    AdminToolsDeliveryOperations,
    BIconList,
    BIconClipboard,
    BIconArchive,
    BIconBox,
    BIconTruck,
    BIconFileText,
    BIconExclamationTriangle,
    BIconCalendar
  },

  data() {
    return {
      drawerOpen: false,
      activeTabIndex: 0,
      isMobile: false,
      packet: { userDetails: {} },
      tabs: [
        {
          title: "DELIVERY CALENDAR",
          icon: "calendar",
          roles: ["admin", "accountmanager", "officeuser", "officemanager", "locationadmin"],
          component: "AdminToolsDeliveryCalendar"
        },
           {
          title: "DELIVERY TRIPS",
          icon: "calendar",
          roles: ["admin", "accountmanager", "officeuser", "officemanager", "locationadmin"],
          component: "AdminToolsDeliveryOperations"
        }
      ]
    };
  },

  computed: {
    filteredTabs() {
      const role = this.packet.userDetails.userrole || "";
      return this.tabs.filter(t => t.roles.includes(role));
    },
    activeTabTitle() {
      const tab = this.filteredTabs[this.activeTabIndex];
      return tab ? tab.title : "Menu";
    },
    activeTabComponent() {
      const tab = this.filteredTabs[this.activeTabIndex];
      return tab ? tab.component : null;
    }
  },

  methods: {
    selectTab(index) {
      this.activeTabIndex = index;
      this.drawerOpen = false;
    },
    handleResize() {
      this.isMobile = window.innerWidth < 768;
    },
    loadUser() {
      try {
        this.packet = JSON.parse(localStorage.packet || "{}");
        this.packet.userDetails = JSON.parse(localStorage.userDetails || "{}");
      } catch (err) {
        console.error("Error loading user:", err);
      }
    }
  },

  created() {
    this.loadUser();
  },

  mounted() {
    this.handleResize();
    window.addEventListener("resize", this.handleResize);
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  }
};
</script>

<style scoped>
@media (max-width: 767px) {
  .b-tabs {
    display: none;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/DeliveryCalendar/DeliveryCalendarMain.vue